/**
 * Feature flags — funzioni nascoste senza cancellare il codice.
 * Riattivare solo quando il servizio è realmente attivo.
 */
// Servizi a pagamento (abbonamento Plus, booking Host, vendita prodotti, offerte parrocchie)
export const SHOW_PAID_SERVICES = false;

// Piazza Social in home (BLOCCO E): si mostra solo quando la Piazza ha
// abbastanza contenuti reali. Oggi la sezione usa cartoline dimostrative
// locali — resta nascosta finché i post reali in Piazza non raggiungono
// almeno HOME_PIAZZA_MIN_POSTS. Riattivare collegando la sezione al feed
// reale /api/wall e impostando il flag a true.
export const HOME_PIAZZA_MIN_POSTS = 10;
export const SHOW_HOME_PIAZZA_FEED = false;
